import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AppConfig } from "src/app/configs/app.config";
import { AdvertiserService } from "src/app/core/services/advertiser.service";

@Component({
  selector: 'app-advertiser-selection',
  templateUrl: './advertiser-selection.component.html',
  styleUrls: ['./advertiser-selection.component.scss']
})
export class AdvertiserSelectionComponent implements OnInit {
  @Output() step_change = new EventEmitter<any>();
  @Input() step_input: any;
  @Input() save_and_next_step: boolean = false;
  @Input() save_step: boolean = true;

  advtdataSource: MatTableDataSource<any>;
  @ViewChild("advertiserPaginator") advtpaginator: MatPaginator;
  @ViewChild("advertiserTableSort") advtsort: MatSort;

  dataSourceAdvSelected: MatTableDataSource<any>;
  @ViewChild("AdvPaginatorSelected") paginatorAdvSelected: MatPaginator;
  @ViewChild("AdvSortSelected") sortAdvSelected: MatSort;

  displayedColumns: string[] = ["checkbox", "advertiser_name", "id", "state"];
  showSearchInput: boolean = false;
  showSearchInputSelected: boolean = false;
  route: string;

  allAdvertisers: Array<any> = [];
  selectedAdvertisers: Array<any> = [];
  save_and_next: boolean;
  save: boolean;
  advertiserCount: number;
  totalAdvertCount: number;
  search_params = {};

  constructor(
    public advertiserService: AdvertiserService,
  ) {}

  ngOnInit(): void {
    this.selectedAdvertisers = this.step_input.advertisers;
    this.route = this.step_input.route;
    this.save_and_next = this.save_and_next_step;
    this.save = this.save_step;
    this.getAdvertisers();
  }

  updateTable(tableCount) {
    this.advtdataSource = new MatTableDataSource(this.allAdvertisers);
    this.advtdataSource.paginator = this.advtpaginator;
    this.advtdataSource.sort = this.advtsort;
    this.advtdataSource._updatePaginator(tableCount);
  }

  updateSelectedTable() {
    this.dataSourceAdvSelected = new MatTableDataSource(this.selectedAdvertisers);
    this.dataSourceAdvSelected.paginator = this.paginatorAdvSelected;
    this.dataSourceAdvSelected.sort = this.sortAdvSelected;
  }

  searchAdvertiser(event) {
    this.search_params['search_term'] = (event.target as HTMLInputElement).value;
    // const filterValue = (event.target as HTMLInputElement).value;
    // let params = {};
    // params = {
    //   search_term: filterValue,
    // };
    // if (filterValue.length == 0) {
    //   params = {};
    // }
    this.getAdvertisers(this.search_params);
    // this.advtdataSource.filter = filterValue.trim().toLowerCase();

    // if (this.advtdataSource.paginator) {
    //   this.advtdataSource.paginator.firstPage();
    // }
  }

  handlePageEvent(event: PageEvent) {
    this.advertiserCount = event.length;
    let requested_page = event.pageSize * (event.pageIndex + 1);
    if (requested_page > this.allAdvertisers.length) {
      let params = {
        ...this.search_params,
        start_element: event.pageSize >= this.allAdvertisers.length ? event.pageSize : this.allAdvertisers.length + this.selectedAdvertisers.length,

        num_elements: 100,
      };
      this.getAdvertisers(params, true);
    }
  }

  getAdvertisers(params = {}, merge = false) {
    this.advertiserService.list(params).subscribe((res) => {
      if (merge) {
        this.allAdvertisers = this.allAdvertisers.concat(res.data);
        this.updateSelectedTable();
        this.updateTable(this.advertiserCount);
      } else {
        this.allAdvertisers = res.data;
        this.advertiserCount = this.totalAdvertCount = res.count;
        this.updateSelectedTable();
        this.updateTable(this.totalAdvertCount);
      }
      if (this.selectedAdvertisers.length > 0) {
        this.selectedAdvertisers.forEach(adv => {
          this.allAdvertisers = this.allAdvertisers.filter(ele => ele.id != adv.id)
        });
        this.updateSelectedTable();
        this.advertiserCount = params['search_term']? this.allAdvertisers.length:this.totalAdvertCount - this.selectedAdvertisers.length;
        this.updateTable(this.advertiserCount);
      }
    });
  }

  addAdvertisers(row) {
    this.selectedAdvertisers.push(row)
    this.allAdvertisers = this.allAdvertisers.filter((deal) => deal.id != row.id);
    this.updateSelectedTable();
    this.advertiserCount = this.advertiserCount - 1;
    this.updateTable(this.advertiserCount);
  }

  removeAdvertiser(row) {
    this.selectedAdvertisers = this.selectedAdvertisers.filter((ele) => ele.id != row.id);
    this.allAdvertisers.unshift(row);
    this.updateSelectedTable();
    this.advertiserCount = this.advertiserCount + 1;
    this.updateTable(this.advertiserCount);
  }

  removeAllAdvertisers() {
    this.selectedAdvertisers.forEach(adv => {
      this.removeAdvertiser(adv)
    })
    this.advertiserCount = this.totalAdvertCount;
  }

  back() {
    this.step_change.emit({
      previous: true,
      advertisers: this.selectedAdvertisers
    });
  }

  proceed(save_only: boolean = false) {
    this.step_change.emit({
      advertisers: this.selectedAdvertisers,
      save_only: save_only
    });
  }

}
